import { render, staticRenderFns } from "./BoitesList.vue?vue&type=template&id=001b1a96&scoped=true&"
import script from "./BoitesList.vue?vue&type=script&lang=js&"
export * from "./BoitesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b1a96",
  null
  
)

export default component.exports